<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
.wrapCenter{
  width: 100%;
  max-width: 1200px;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/App.vue